import { ChangeDetectionStrategy, Component, OnInit, ViewChild, input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonInput, IonicModule, ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { EducationBodyDto } from 'src/app/settings/interfaces/education_body_dto';
import { addEducationBody, updateEducationBody } from 'src/app/settings/ngrx/settings.action';
import { ModeService } from 'src/app/utils/mode.service';

@Component({
    selector: 'app-education-body-form',
    templateUrl: './education-body-form.component.html',
    styleUrls: ['./education-body-form.component.scss'],
    imports: [IonicModule, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EducationBodyFormComponent implements OnInit {
  educationBodyForm: FormGroup;
  readonly educationTitle = input<number>(undefined);
  readonly rowOrder = input<number>(undefined);
  readonly educationBody = input<EducationBodyDto>(undefined);
  @ViewChild("input") input!: IonInput;

  constructor(
    private fb: FormBuilder,
    public modeService: ModeService,
    private modalController: ModalController,
    private store: Store<any>
  ) {
    this.educationBodyForm = this.fb.group({
      body: [null, Validators.required],
      hyperlink: [null],
    });
  }

  ngOnInit() {
    const educationBody = this.educationBody();
    if (educationBody) {
      this.educationBodyForm.patchValue(educationBody);
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
        this.input.setFocus();
    },150);
  }

  async cancel() {
    this.modalController.dismiss();
    if (await this.modalController.getTop()) {
      this.modalController.dismiss();
    }
  }

  async saveEducationBody() {
    if (this.educationBodyForm.valid) {
      this.educationBodyForm.value.education_title_id = this.educationTitle();
      this.educationBodyForm.value.row_order = this.rowOrder();
      const educationBody = this.educationBody();
      if (educationBody) {
        this.educationBodyForm.value.education_body_id = educationBody.education_body_id;
        this.store.dispatch(
          updateEducationBody({
            educationBody: this.educationBodyForm.value,
          })
        )
      } else {
        this.store.dispatch(
          addEducationBody({
            educationBody: this.educationBodyForm.value,
          })
        );
      }
      this.modalController.dismiss();
    }
  }
}
